import PropTypes from 'prop-types';
import { useMemo } from 'react';

import CarouselBox from 'components/CarouselBox';

import { isFirstItem } from 'lib/array';

import AdCarouselItem from './AdCarouselItem';

const AdsCarousel = ({ ads = [], className, gaEventCategory }) => {
  const adsSortedByPosition = useMemo(
    () => [...ads].sort((adA, adB) => adA.position - adB.position),
    [ads]
  );

  return (
    <CarouselBox
      arrowsProps={{
        className: 'hidden lg:block',
        offsetX: { left: '-left-2', right: '-right-2' },
      }}
      carouselProps={{ className: 'w-full' }}
      className={className}
      itemProps={{
        slidesPerView: 1,
        itemSize: 280,
        breakpoints: {
          md: { itemSize: 576, slidesPerView: 1 },
          lg: { itemSize: 1152, slidesPerView: 1 },
        },
      }}
      list={adsSortedByPosition}
      render={(
        { id, url, image, mobileImage, tabletImage, description, visibility },
        index
      ) => (
        <AdCarouselItem
          key={url}
          description={description}
          desktopImage={image}
          gaEventCategory={gaEventCategory}
          id={id}
          mobileImage={mobileImage}
          priority={isFirstItem(index)}
          tabletImage={tabletImage}
          url={url}
          visibility={visibility}
        />
      )}
      autoPlay
      full
      showArrows
      useFixedSize
    />
  );
};

AdsCarousel.propTypes = {
  ads: PropTypes.arrayOf(
    PropTypes.shape({
      description: PropTypes.string.isRequired,
      id: PropTypes.number.isRequired,
      image: PropTypes.string.isRequired,
      mobileImage: PropTypes.string.isRequired,
      tabletImage: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      visibility: PropTypes.string.isRequired,
    })
  ),
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  gaEventCategory: PropTypes.string.isRequired,
};

export default AdsCarousel;
